// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__VeQqD","table":"Market_table__2RxQw","row":"Market_row__k6PlM","col":"Market_col__1_3z7","foot":"Market_foot__3O7Eg","arrow":"Market_arrow__3FjMG"};